export default {
  'stopPayments.refName': 'stopPayments',
  'stopPayments.gridName': 'StopPayments',

  'stopPayments.title': 'Add Stop Request(s)',
  'stopPayments.pathName': '/stop-payments-request',
  'stopPayments.requestPayload': 'StopPay',

  // Column Names
  // Default Columns
  'stopPayments.status': 'Status',
  'stopPayments.accountName': 'Account Name',
  'stopPayments.accountNumber': 'Account Number',
  'stopPayments.checkNumber': 'Check Number/Range',
  'stopPayments.amount': 'Amount',
  'stopPayments.stopReason': 'Stop Reason',
  'stopPayments.expirationDate': 'Expiration Date',
  'stopPayments.responseDescription': 'Response Description',

  // Optional Columns
  'stopPayments.issueDate': 'Check Issue Date',
  'stopPayments.payee': 'Payee',
  'stopPayments.bankTraceNumber': 'Bank Trace Number',
  'stopPayments.stopDate': 'Stop Date',
  'stopPayments.initiatedBy': 'Initiated By'
};
